@if (showDialog) {
  <div class="dialog confirm-dialog">
    @if (showCloseButton) {
      <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
    }
    <div mat-dialog-title>
      @if (translateTitle) {
        <h1>{{ data.title | xTranslate }}</h1>
      } @else {
        <h1 l10nTranslate>shared.alert</h1>
      }
    </div>

    <div mat-dialog-content class="confirm-container">
      <div class="viewmode">
        <mat-icon [ngClass]="data.iconClass">
          @if (data.icon) {
            {{ data.icon }}
          } @else {
            <em class="fa fa-exclamation-triangle"></em>
          }
        </mat-icon>
        <div class="alert-msgs">
          <!-- CONFIRM MESSAGES -->
          @if (!data.duplicateAlert) {
            <span class="message">{{ data.message }}</span>
          }

          @if (data?.multipleMessages?.length > 0) {
            <!-- MULTI MESSAGE VIEW -->
            @if (data.isBulletedMessages) {
              <!-- BULLETED MULTI MESSAGE -->
              <ul class="bulleted-multi-message">
                @for (message of data.multipleMessages; track $index) {
                  <li>{{ message }}</li>
                }
              </ul>
            } @else {
              <!-- DEFAULT MULTI MESSAGE -->
              @for (message of data.multipleMessages; track $index) {
                <span class="message">{{ message }}</span>
              }
            }
          }

          <!-- LEAVE MESSAGE -->
          @if (data.leaveMessage) {
            <span class="message">{{ data.leaveMessage }}</span>
          }
          @if (data.rememberMyChoiceDialogId) {
            <div>
              <mat-checkbox [(ngModel)]="rememberChoice">
                {{ data.doNotRemindMeText }}
              </mat-checkbox>
            </div>
          }
          @if (data.duplicateAlert) {
            <div>
              @if (data.duplicateAlert.entity === 'property') {
                <span>
                  {{
                    'recordsSearch.duplicateRecordExists.' + data.duplicateAlert.entity + '.withExistingId' | xTranslate
                  }}
                  <miq-goes-to-record
                    [id]="data.duplicateAlert.existingId"
                    [type]="data.duplicateAlert.entity"
                    target="_blank"
                    >{{ data.duplicateAlert.existingId }}</miq-goes-to-record
                  >
                </span>
              }
              <span>
                {{
                  'recordsSearch.duplicateRecordExists.' + data.duplicateAlert.entity + '.additionalInfo' | xTranslate
                }}
              </span>
            </div>
          }
        </div>
      </div>

      @if (data.cancelText || data.confirmText) {
        <div mat-dialog-actions>
          @if (data.cancelText) {
            <button mat-button color="primary" class="fx--mr-xs" (click)="selectOption(data.swap ?? false)">
              {{ data.cancelText }}
            </button>
          }
          @if (data.confirmText) {
            <button mat-flat-button color="primary" (click)="selectOption(!data.swap)" cdkFocusInitial>
              {{ data.confirmText }}
            </button>
          }
        </div>
      }
    </div>
  </div>
}
